<style>
.baoxian .ivu-affix {
    z-index: 0 !important;
}
</style>
<template>
    <div>
        <section class="clearfix baoxian">
            <Affix :offset-top="60">
                <compWrapper title="投保规则" theme="primary" class="pull-left width-45per">
                    <Alert show-icon>
                        <span v-html="$t('fbb.rulescustomerorg.insuranceRegulation',{defaultValue:'投保规则提示信息'})"></span>
                    </Alert>
                    <Form class="margin-15" :label-width="110" :model="formData">
                        <FormItem v-if="type == 'query'" label="规则名称">
                            <div>{{ formData.ruleName }}</div>
                        </FormItem>
                        <FormItem v-else label="规则名称" :rules="required" prop="ruleName">
                            <Input v-model="formData.ruleName"></Input>
                        </FormItem>
                    </Form>
                    <div class="margin-15" style="margin-top:-20px">
                        <div style="line-height:45px">可选条件</div>
                        <Collapse simple v-model="collValue">
                            <Panel name="1">
                                基础信息
                                <p slot="content">
                                    <Checkbox class="font-12 margin-left-30" v-model="channelflag"
                                        :disabled="type == 'query'">渠道账号</Checkbox>
                                </p>
                            </Panel>
                            <Panel name="2">
                                仓储物流
                                <p slot="content">
                                    <Checkbox class="font-12 margin-left-30" v-model="carrierflag"
                                        :disabled="type == 'query'">发货方式</Checkbox>
                                </p>
                            </Panel>
                            <Panel name="3">
                                产品信息
                                <p slot="content">
                                    <CheckboxGroup>
                                        <Checkbox class="font-12 margin-left-30" v-model="lineflag"
                                            :disabled="type == 'query'">项目</Checkbox>
                                        <Checkbox class="font-12" v-model="prodflag" :disabled="type == 'query'">产品
                                        </Checkbox>
                                        <Checkbox class="font-12" v-model="oneprodflag" :disabled="type == 'query'">单产品重量
                                        </Checkbox>
                                        <Checkbox class="font-12" v-model="totalprodflag" :disabled="type == 'query'">产品总重量
                                        </Checkbox>
                                        <Checkbox class="font-12" v-model="prodattrflag" :disabled="type == 'query'">产品属性
                                        </Checkbox>
                                    </CheckboxGroup>
                                </p>
                            </Panel>
                        </Collapse>
                    </div>
                </compWrapper>
            </Affix>

            <div class="pull-right width-50per">
                <compDetail ref="detail" :detailDatas="formData"
                    :showFlag="{ channelflag, carrierflag, lineflag, prodflag, oneprodflag, totalprodflag, prodattrflag }"
                    :type="type"></compDetail>
            </div>
        </section>
        <div class="text-right" v-if="type != 'query'">
            <Button type="primary" @click="submit">保存</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import {
    HttpSaveInsuranceRuleOne,
    HttpGetInsuranceRuleOne
} from "@/service/credit";
import compDetail from './detail'
export default {
    props: ['querytype', 'activeid'],
    components: {
        compDetail
    },
    data() {
        return {
            collValue: [1, 2, 3],
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            formData: {},
            fruit: [],
            single: [],
            required: [{
                required: true,
                message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
            }],
            channelflag: false,
            carrierflag: false,
            lineflag: false,
            prodflag: false,
            oneprodflag: false,
            totalprodflag: false,
            prodattrflag: false,
        }
    },
    created() {
        this.getDetail()
    },
    methods: {
        getDetail() {
            if (this.type != 'add') {
                HttpGetInsuranceRuleOne({
                    ruleId: this.id
                }).then(res => {
                    this.formData = res.data;
                    this.detailDatas = res.data;
                    if (res.data.channelList.length > 0) {
                        this.channelflag = true;
                    }
                    if (res.data.carrierCodeList.length > 0) {
                        this.carrierflag = true;
                    }
                    if (res.data.productLineList.length > 0) {
                        this.lineflag = true;
                    }
                    if (res.data.skuList.length > 0) {
                        this.prodflag = true;
                    }
                    if (res.data.singerSkuWeight.length > 0) {
                        this.oneprodflag = true;
                    }
                    if (res.data.totalSkuWeight.length > 0) {
                        this.totalprodflag = true;
                    }
                    if (res.data.productAttribute) {
                        if (res.data.productAttribute.isFragile == 1) {
                            this.prodattrflag = true;
                        } else {
                            this.prodattrflag = false;
                        }
                    }
                }, err => {
                    this.$Message.error({ content: err.message, duration: 20, closable: true });
                })
            }
        },
        errorMsg() {
            return this.$Message.error('请填写必须项！')
        },
        submit() {
            if (!this.channelflag && !this.carrierflag && !this.lineflag && !this.prodflag && !this.oneprodflag && !this.totalprodflag && !this.prodattrflag) {
                this.$Message.error('请选择条件！');
                return;
            }
            let detailData = this.$refs.detail;
            if (!this.formData.ruleName || !detailData.formData.insuranceServiceId) {
                this.errorMsg();
                return;
            }
            let channelList = null, carrierCodeList = null, productLineList = null, skuList = null, singerSkuWeight = [], totalSkuWeight = [], productAttribute = null;
            // 判断渠道账号
            if (this.channelflag) {
                if (detailData.formData.targetAccountList.length < 1) {
                    this.errorMsg();
                    return;
                } else {
                    channelList = detailData.formData.targetAccountList.map(item => {
                        return {
                            content: item
                        }
                    })
                }
            }

            // 判断发货方式
            if (this.carrierflag) {
                if (detailData.formData.carrier.length == 0) {
                    this.errorMsg();
                    return;
                } else {
                    carrierCodeList = detailData.formData.carrier.map(item => {
                        return {
                            content: item
                        }
                    })
                }
            }

            // 判断项目，产品，单产品，产品总量，产品属性
            if (this.lineflag) {
                if (detailData.formData.targetProductList.length < 1) {
                    this.errorMsg();
                    return;
                } else {
                    productLineList = detailData.formData.targetProductList.map(item => {
                        return {
                            content: item
                        }
                    })
                }
            }
            if (this.prodflag) {
                if (!detailData.formData.prodErpskuList) {
                    this.errorMsg();
                    return;
                } else {
                    let prodstr = detailData.formData.prodErpskuList.replace(/\n/g, ",");
                    let prodarr = prodstr.split(',');
                    skuList = prodarr.map(item => {
                        return {
                            content: item
                        }
                    })
                }
            }
            if (this.oneprodflag) {
                if (!detailData.formData.oneprodChoose1 && !detailData.formData.oneprodChoose2) {
                    this.errorMsg();
                    return;
                } else {
                    let data1 = null, data2 = null;
                    if (detailData.formData.oneprodChoose1) {
                        if (!detailData.formData.oneprodWeight1) {
                            this.$Message.error('请填写值!');
                            return;
                        } else {
                            data1 = {
                                sign: detailData.formData.oneprodvalue1 || '',
                                content: detailData.formData.oneprodWeight1 || '',
                            }
                            singerSkuWeight.push(data1)
                        }
                    }
                    if (detailData.formData.oneprodChoose2) {
                        if (!detailData.formData.oneprodWeight2) {
                            this.$Message.error('请填写值!');
                            return;
                        } else {
                            data2 = {
                                sign: detailData.formData.oneprodvalue2 || '',
                                content: detailData.formData.oneprodWeight2 || '',
                            }
                            singerSkuWeight.push(data2)
                        }
                    }
                }
            }
            if (this.totalprodflag) {
                if (!detailData.formData.totalprodChoose1 && !detailData.formData.totalprodChoose2) {
                    this.errorMsg();
                    return;
                } else {
                    let data1 = null, data2 = null;
                    if (detailData.formData.totalprodChoose1) {
                        if (!detailData.formData.totalprodWeight1) {
                            this.$Message.error('请填写值!');
                            return;
                        } else {
                            data1 = {
                                sign: detailData.formData.totalprodvalue1 || '',
                                content: detailData.formData.totalprodWeight1 || '',
                            }
                            totalSkuWeight.push(data1)
                        }
                    }
                    if (detailData.formData.totalprodChoose2) {
                        if (!detailData.formData.totalprodWeight2) {
                            this.$Message.error('请填写值!');
                            return;
                        } else {
                            data2 = {
                                sign: detailData.formData.totalprodvalue2 || '',
                                content: detailData.formData.totalprodWeight2 || '',
                            }
                            totalSkuWeight.push(data2)
                        }
                    }
                }
            }
            if (this.prodattrflag) {
                if (!detailData.formData.isFragile) {
                    this.errorMsg();
                    return;
                } else {
                    productAttribute = { "isFragile": detailData.formData.isFragile ? 1 : 0 }
                }
            } else {
                productAttribute = null
            }
            if (detailData.formData.insuranceProportion < 100 || detailData.formData.insuranceProportion > 130) {
                this.$Message.error('加成比例填写请在范围内！');
                return;
            }
            HttpSaveInsuranceRuleOne({
                id: this.id,
                orgId: global.SYSID,
                ruleName: this.formData.ruleName,
                insuranceServiceId: detailData.formData.insuranceServiceId,
                insuranceType: detailData.formData.insuranceType,
                insuranceProportion: detailData.formData.insuranceProportion,
                channelList,
                productLineList,
                skuList,
                singerSkuWeight,
                totalSkuWeight,
                carrierCodeList,
                productAttribute
            }).then(res => {
                this.$Message.success(res.message);
                this.cancel()
            }, err => {
                this.$Message.error({ content: err.message, duration: 20, closable: true });
            })
        },
        cancel() {
            this.$router.push({
                name: "rulescustomerorgList"
            })
        }
    }
}
</script>